import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setK3Docs } from '../../actions';
import {
  Modal,
  Form,
  Button,
  Row,
  Col,
  InputGroup
} from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { BsCode } from 'react-icons/bs';

class K3DocCreator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      doc_mid: '',
      ref_id: '',
      friendly_version: '',
      title: '',
      description: '',
      content: '',
      tags: '',
      type: 'k3_document',
      metadata: '{}',
      preview: false,
      sourceEdit: false,
      sourceJson: ''
    };
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const docData = {
        ...this.state,
        tags: this.state.tags.split(',').map(tag => tag.trim()).filter(Boolean),
        metadata: JSON.parse(this.state.metadata)
      };
      await this.props.setK3Docs([docData], { generate_version: true });
      this.props.onHide();
    } catch (error) {
      console.error('Error creating document:', error);
    }
  };

  togglePreview = () => {
    this.setState(prevState => ({ preview: !prevState.preview }));
  };

  toggleSourceEdit = () => {
    this.setState(prevState => ({ sourceEdit: !prevState.sourceEdit }));
  };

  handleSourceJsonChange = (e) => {
    this.setState({ sourceJson: e.target.value });
  };

  handleSourceSubmit = async (e) => {
    e.preventDefault();
    try {
      const docData = JSON.parse(this.state.sourceJson);
      await this.props.setK3Docs([docData], { generate_version: true });
      this.props.onHide();
    } catch (error) {
      console.error('Error creating document from source:', error);
      alert('Invalid JSON format. Please check your input.');
    }
  };

  render() {
    const { show, onHide } = this.props;
    const {
      doc_mid,
      ref_id,
      friendly_version,
      title,
      description,
      content,
      tags,
      type,
      metadata,
      preview,
      sourceEdit,
      sourceJson
    } = this.state;

    return (
      <Modal show={show} onHide={onHide} size="lg">
        <Modal.Header closeButton>
          <div className="d-flex justify-content-between w-100 align-items-center">
            <Modal.Title>Create New Document</Modal.Title>
            <Button
              variant="outline-dark"
              size="sm"
              onClick={this.toggleSourceEdit}
            >
              <BsCode className="me-1" /> Source Edit
            </Button>
          </div>
        </Modal.Header>
        <Modal.Body>
          {sourceEdit ? (
            <Form onSubmit={this.handleSourceSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Source JSON</Form.Label>
                <Form.Control
                  as="textarea"
                  value={sourceJson}
                  onChange={this.handleSourceJsonChange}
                  rows={15}
                  placeholder="Paste your document JSON here"
                  required
                />
              </Form.Group>
            </Form>
          ) : (
            <Form onSubmit={this.handleSubmit}>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Document MID</Form.Label>
                    <Form.Control
                      type="text"
                      name="doc_mid"
                      value={doc_mid}
                      onChange={this.handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Friendly Version</Form.Label>
                    <Form.Control
                      type="text"
                      name="friendly_version"
                      value={friendly_version}
                      onChange={this.handleChange}
                      placeholder="Optional"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Type</Form.Label>
                    <Form.Select
                      name="type"
                      value={type}
                      onChange={this.handleChange}
                    >
                      <option value="k3_document">K3 Document</option>
                      <option value="main_message">Commit Main Message</option>
                      <option value="sub_message">Commit Sub Message</option>
                      <option value="system_prompt">System Prompt</option>
                      <option value="agent_prompt">Agent Prompt</option>
                      <option value="agent_data">Agent Data</option>
                      <option value="other">Other</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Reference ID</Form.Label>
                    <Form.Control
                      type="text"
                      name="ref_id"
                      value={ref_id}
                      onChange={this.handleChange}
                      placeholder="Optional"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  name="title"
                  value={title}
                  onChange={this.handleChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  name="description"
                  value={description}
                  onChange={this.handleChange}
                  rows={3}
                  placeholder="Enter document description..."
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Tags (comma-separated)</Form.Label>
                <Form.Control
                  type="text"
                  name="tags"
                  value={tags}
                  onChange={this.handleChange}
                  placeholder="tag1, tag2, tag3"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <Form.Label>Content</Form.Label>
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={this.togglePreview}
                  >
                    {preview ? 'Edit' : 'Preview'}
                  </Button>
                </div>
                {preview ? (
                  <div className="border p-3">
                    <ReactMarkdown
                      remarkPlugins={[remarkGfm]}
                      rehypePlugins={[rehypeRaw]}
                    >
                      {content}
                    </ReactMarkdown>
                  </div>
                ) : (
                  <Form.Control
                    as="textarea"
                    name="content"
                    value={content}
                    onChange={this.handleChange}
                    rows={10}
                    required
                  />
                )}
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Metadata (JSON)</Form.Label>
                <Form.Control
                  as="textarea"
                  name="metadata"
                  value={metadata}
                  onChange={this.handleChange}
                  rows={3}
                />
              </Form.Group>
            </Form>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          {sourceEdit ? (
            <Button variant="primary" onClick={this.handleSourceSubmit}>
              Create from Source
            </Button>
          ) : (
            <Button variant="primary" onClick={this.handleSubmit}>
              Create
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

export default connect(null, { setK3Docs })(K3DocCreator); 